import React from "react";
import "./AboutContent.css";

function ProductionsContent() {
  return (
    <>
      <section className="hero">
        <div className="heading">
          <h1>Productions</h1>
          <h3>
            <a href="/productions">Current Productions</a> -{" "}
            <a href="/2024productions">2024</a> -{" "}
            <a href="/2025productions">2025</a> -{" "}
            <a href="/2026productions">2026</a>
          </h3>
        </div>
      </section>

      <br></br>
      <div className="container">
        <div className="hero-content">
          <h2>Set In Chicago</h2>
          <h3>Spooky Movie Sequels Improv Comedy</h3>
          <h4>de Maat Studio Theater @ Second City</h4>
          <p>Thursday Nights @ 7:30pm</p>
          <p>October 1st - 29th</p>
          <button type="button" class="btn btn-outline-dark btn-rounded">
            <a href="https://www.secondcity.com/shows/chicago/set-in-chicago-improvised-spooky-movie-sequels-chi">
              TICKETS
            </a>
          </button>
        </div>
        <div className="hero-image-left">
          <img src="images/setinchicago5.jpg" alt="kittyandkellie" />
        </div>
      </div>

      {/* <br></br> */}
      {/* <div className="container reverse-order">
        <div className="hero-image-left">
          <img src="images/setinchicago3.jpg" alt="littlehelp" />
        </div>
        <div className="hero-content">
          <h2>Set in Chicago</h2>
          <h3>Movie Sequels Improv Comedy</h3>
          <h4>de Maat Studio Theater @ Second City</h4>
          <p>Thursday Nights @ 7:30pm</p>
          <p>March 12th - April 30th</p>
          <button type="button" class="btn btn-outline-dark btn-rounded">
            <a href="https://www.secondcity.com/shows/chicago/set-in-chicago-improvised-movie-sequels-chi">
              TICKETS
            </a>
          </button>
        </div>
      </div> */}
    </>
  );
}

export default ProductionsContent;
